import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import './toggle-switch.scss';
import { DashboardContext } from '../../../context';

import { default as t } from '../../../utils/i18n';
import { AppTooltip } from '..';
const initialPauseState = {
  lastModifiedBy: null,
  lastModifiedOn: null,
  status: null
}
const ToggleSwitch = ({ id, name, checked, optionLabels, disabled, onToggle, pauseAdsetData }) => {

  const [pauseUserData, setPauseUserData] = useState(initialPauseState);

  useEffect(() => {
    setPauseUserData(pauseAdsetData)
  }, [pauseAdsetData]);

  const { lastModifiedBy, lastModifiedOn } = pauseUserData;

  // const { dashData } = useContext(DashboardContext);
  // const { pauseAdset } = dashData;
  // ////console.log(pauseAdset);
  // const { lastModifiedBy, lastModifiedOn } = pauseAdset;
  return (
    <>

      <div className={'toggle-btn'}>
        <input
          type="checkbox"
          name={name}
          className="toggle-btn-checkbox"
          id={id}
          checked={checked}
          onChange={e => onToggle(e.target.checked)}
          disabled={disabled}
        />
        {id ? (
          <label className="toggle-btn-label" htmlFor={id}>
            {/* <span
              className={disabled ? 'toggle-btn-inner toggle-btn-disabled' : 'toggle-btn-inner'}
            /> */}
            <span
              className={`off-label ${!checked ? 'checked' : ''}`}>
              {optionLabels[0]}
            </span>
            {/* <span
              className={
                disabled ? 'toggle-btn-btn toggle-btn-disabled' : 'toggle-btn-btn active-btn'
              }
            >
              {checked ? t('pauseAdset.toggle.onChecked.label') : t('pauseAdset.toggle.offChecked.label')}
            </span> */}
            <span
            className={`on-label ${checked ? 'checked' : ''}`}>
                {optionLabels[1]}
            </span>

          </label>
        ) : null}
      </div>
    </>
  );
};

ToggleSwitch.defaultProps = {
  optionLabels: ['Basic', 'Advanced'],
  pauseAdsetData: initialPauseState
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  disabled: PropTypes.bool
};

export default ToggleSwitch;
